<style>
	:global(.mdc-text-field) {
		border-top-left-radius: 4px;
		border-top-left-radius: var(--mdc-shape-small, 4px);
		border-top-right-radius: 4px;
		border-top-right-radius: var(--mdc-shape-small, 4px);
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		display: inline-flex;
		align-items: baseline;
		position: relative;
		box-sizing: border-box;
		overflow: visible;
		will-change: color;
		width: 100%;
	}
	:global(.date-time-picker) {
		width: 100%;
	}
	:global(.mdc-menu-surface) {
		width: 100%;
	}
</style>

<script lang="ts">
	import type { MenuSurfaceComponentDev } from '@smui/menu-surface';
	import MenuSurface from '@smui/menu-surface';
	import Textfield from '@smui/textfield';
	import { DatePicker } from 'date-picker-svelte';
	import { formatDate } from '../../../functions';

	export let label = 'Range Data Picker';
	export let valueStart = null;
	export let valueEnd = null;
	export let start = 'Da';
	export let end = 'A';
	export const format = 'yyyy/MM/dd';
	export let min = new Date('1970-01-01T00:00:00');
	export let max = new Date('2100-12-31T00:00:00');
	export const disabled = false;
	export let Class = '';

	let surface: MenuSurfaceComponentDev;

	$: {
		if (valueStart) {
			valueStart = new Date(valueStart);
			valueStart.setHours(11, 0, 0);
		} else {
			valueStart = null;
		}

		if (valueEnd) {
			valueEnd = new Date(valueEnd);
			valueEnd.setHours(11, 0, 0);
		} else {
			valueEnd = null;
		}
	}
</script>

<div class="mdc-text-field smui-text-field--standard mdc-text-field--label-floating w-full {Class}" on:click="{() => surface.setOpen(true)}" on:keydown="{() => surface.setOpen(true)}" tabindex="0" role="button">
	<span class="mdc-floating-label mdc-floating-label--float-above pb-1">{label}</span>
	<div class="flex-nowrap flex flex-row w-full gap-5" on:click="{() => surface.setOpen(true)}" on:keydown="{() => surface.setOpen(true)}" tabindex="0" role="button">
		<Textfield label="{!valueStart ? start : ''}" value="{valueStart ? formatDate(valueStart) : ''}" class="w-full pointer-events-none" on:click="{() => surface.setOpen(true)}"/>
		<Textfield label="{!valueEnd ? end : ''}" value="{valueEnd ? formatDate(valueEnd) : ''}" class="w-full pointer-events-none" on:click="{() => surface.setOpen(true)}"/>
	</div>
	<MenuSurface bind:this="{surface}" anchorCorner="BOTTOM_LEFT">
		<div class="xl:flex-nowrap flex flex-wrap justify-center w-full">
			<DatePicker
				bind:value="{valueStart}"
				on:select="{() => {
					if (valueStart && valueEnd) surface.setOpen(false);
				}}"
				min="{min}"
				max="{valueEnd ?? max}"
			/>
			<DatePicker
				bind:value="{valueEnd}"
				on:select="{() => {
					if (valueStart && valueEnd) surface.setOpen(false);
				}}"
				min="{valueStart ?? min}"
				max="{max}"
			/>
		</div>
	</MenuSurface>
</div>
